import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/credit-bill-deposit-detail',
            name: 'admin-credit-bill-deposit-detail',
            component: () => import(/* webpackChunkName: "page-admin-credit-bill-credit-bill-deposit-detail" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "订单详情"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信账单"
                                        },
                                        {
                                                  name: "订单详情"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
